import React from "react";
import { useIntl } from "react-intl";

import styles from "../StartScreen/SelectScenario.module.css";
import inputElementStyles from "../styles/InputElements.module.css";

interface MyProps {
  searchString: string;
  setSearchString: (searchString: string) => void;
  placeholder: string;
  autoFocus: boolean;
  setPage: (page: number) => void;
  inputFieldRef?: React.MutableRefObject<HTMLInputElement | null>;
  onEnter?: () => void;
}

const SearchBar: React.FC<MyProps> = (props: MyProps) => {
  const { searchString, setSearchString, placeholder, autoFocus, setPage, inputFieldRef, onEnter } =
    props;

  const intl = useIntl();

  return (
    <div className={styles.SearchBoxOnNameContainer}>
      <button className={styles.SearchIcon}>
        <img src="./assets/images/search_icon.svg" alt="search-icon" />
      </button>
      <input
        className={`${inputElementStyles.Input} ${inputElementStyles.Padding} ${styles.SearchBoxOnName}`}
        type="text"
        onChange={(e) => {
          setSearchString(e.target.value);
          setPage(1);
        }}
        value={searchString}
        placeholder={placeholder}
        autoFocus={autoFocus}
        ref={inputFieldRef || undefined}
        onKeyPress={(event) => onEnter && event.key === "Enter" && onEnter()}
      />
      <button
        className={styles.RemoveSearchIcon}
        onClick={() => {
          setSearchString("");
          setPage(1);
        }}
        disabled={searchString === ""}
        title={intl.formatMessage({
          id: "select_model.tooltip_clear_search_model",
          defaultMessage: "Clear search term",
        })}
      >
        X
      </button>
    </div>
  );
};

export default SearchBar;
